
import Section from "./Section";
import { useGetLeaderBoard } from "../../queries/dashboard";

const Leaderboard = () => {
    const { data: leaderboardData, isPending: isLeaderboardDataPending } = useGetLeaderBoard();

    const topUsers = leaderboardData?.topUsers || [];

    return (
        <Section title={"Leaderboard"} isLoading={isLeaderboardDataPending} gridCols={1} innerPadding={0}>
            <div className="bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] p-4 py-2 overflow-y-auto">
                <div className="flex items-center justify-between font-semibold border-b border-border pb-2">
                    <div className="w-1/12">#</div>
                    <div className="w-7/12">Username</div>
                    <div className="w-4/12 text-right">Points</div>
                </div>

                {topUsers.length === 0 ? (
                    <div className="py-6 text-center text-gray-500">No leaderboard data available.</div>
                ) : (
                    topUsers.map((user, idx) => {
                        const username = user.username || `${user?.name?.firstName || ''} ${user?.name?.lastName || ''}`.trim();
                        return (
                            <div key={user._id || idx} className="flex items-center justify-between py-2 border-b border-border text-base">
                                <div className="w-1/12">{idx + 1}</div>
                                <div className="w-7/12">{username || '—'}</div>
                                <div className="w-4/12 text-right text-primary font-bold">{user.points ?? 0}</div>
                            </div>
                        );
                    })
                )}
            </div>
        </Section>
    );
};

export default Leaderboard;